var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-container[data-v-2d385f42]{display:flex;flex-direction:column;margin:0}.login-splash[data-v-2d385f42]{background-image:linear-gradient(135deg,#007bff,#28a745)}.login-splash-image[data-v-2d385f42]{opacity:.4;background-size:cover;background-image:url(" + escape(require("../assets/login_splash.jpg")) + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d385f42","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/login-page.vue
// module id = 133
// module chunks = 0